import EmptyTableRow from "../../../../common/EmptyTableRow";
import React from "react";
import {OrdersPreviousType} from "../interface";
import PaginationSub from "../../../../../components/common/pagination/PaginationSub";
import {BasicSearchType} from "../../../../../types/common/basic";
import DisplayNumber from "../../../../../components/common/number/DisplayNumber";

interface PropsType {
    ordersPrevious: OrdersPreviousType
    searchParam: BasicSearchType & { newLEnduserValue: string, newShipmentId: string }
    setSearchParam: React.Dispatch<React.SetStateAction<BasicSearchType & {
        newLEnduserValue: string,
        newShipmentId: string
    }>>
}

export default function Tab4({ordersPrevious, searchParam, setSearchParam}: PropsType) {
    const dataList = ordersPrevious.list ?? []
    const totalCount = ordersPrevious.totalCount ?? 0

    return <div className="content_wrap">
        <div className="table_top">
            <h6 className="table_stats">결제 건 목록(<span>{totalCount}</span>건)</h6>
        </div>

        <div className="table_scroll">
            <table className="table table-bordered my_table">
                <thead>
                <tr>
                    <th style={{width: "10%"}}>주문일자</th>
                    <th style={{width: "10%"}}>주문번호</th>
                    <th style={{width: "30%"}}>품목</th>
                    <th>규격</th>
                    <th style={{width: "7%"}}>환종</th>
                    <th style={{width: "8%"}}>환율</th>
                    <th style={{width: "8%"}}>단가</th>
                    <th style={{width: "5%"}}>수량</th>
                    <th style={{width: "9%"}}>금액</th>
                </tr>
                </thead>
                <tbody>
                {dataList.length !== 0 ? (
                    dataList.map((el) => {
                        return el.orderSubjectResList.map(
                            (el2, idx2) => {
                                return (
                                    <tr>
                                        {idx2 === 0 && <>
                                            <td className="text-center"
                                                rowSpan={el.orderSubjectResList.length}>
                                                {el.newDtOrder}
                                            </td>
                                            <td className="text-center"
                                                rowSpan={el.orderSubjectResList.length}>
                                                {el.orderNo}
                                            </td>
                                        </>}
                                        <td className="text-center">{el2.newTxtNmItem}</td>
                                        <td className="text-center">{el2.new_txt_standard}</td>
                                        <td className="text-center">{el2.currencyName}</td>
                                        <td className="text-center"><DisplayNumber value={el2.new_d_exchange_rate}/>
                                        </td>
                                        <td className="text-center"><DisplayNumber value={el2.new_d_unitprice}/></td>
                                        <td className="text-center"><DisplayNumber value={el2.new_i_qty}/></td>
                                        <td className="text-center"><DisplayNumber value={el2.new_d_total}/></td>
                                    </tr>
                                );
                            }
                        );
                    })
                ) : (
                    <EmptyTableRow/>
                )}
                </tbody>
            </table>
        </div>

        <PaginationSub totalCount={totalCount ?? 0}
                       currentPage={searchParam.pageNo}
                       onChangeCallback={(i) =>
                           setSearchParam({...searchParam, pageNo: i})
                       }/>
    </div>
}